// This file is generated by Slice Machine. Update with care!

import LeagueTables from './LeagueTables';

export { LeagueTables };

export const components = {
  league_table: LeagueTables,
};
